import React, {Component, Fragment} from 'react'
import ProgressBar from '../../components/ProgressBar'

export class ServiceCard extends Component {
    state = {

    }

    showHideManagePlan = () => {
        const {myServiceInfoItemIndex} = this.props;

        this.props.showHideManagePlan(myServiceInfoItemIndex);
    }

    render() {
        const {myServiceInfoItem, myServiceInfoItemIndex} = this.props;

        return (
            <Fragment>
                <div className="cp-col col-12 col-lg-6 d-flex">
                    <div className="card card-service">

                        <div className="card-caption">
                            <div className="card-left">

                                <div className="card-icon">
                                    <i className={myServiceInfoItem.serviceModel.icon}/>
                                </div>

                            </div>
                            <div className="card-right">

                                <div className="card-header">
                                    {`My ${myServiceInfoItem.planDescription}`}
                                </div>

                                <div className="card-description">
                                    {`You have ${myServiceInfoItem.serviceLines.length} service ${myServiceInfoItem.serviceLines.length > 1 ? 'lines' : 'line'}.`}
                                </div>

                            </div>
                        </div>

                        <div className="card-body">

                            {/* FOR DEMO PURPOSES - SHOWN ONLY IN FIRST CARD
                            {myServiceInfoItemIndex === 0 && (
                                <div className="card-upgrade">

                                    <div className="card-upgrade-caption">

                                        <h4 className="card-upgrade-title">Upgrade your Data!</h4>

                                        <p className="card-upgrade-description">
                                            Add 5 GB
                                            <span className="badge badge-danger">for just $11.99!</span>
                                        </p>

                                        <button className="btn btn-sm btn-primary">Upgrade</button>

                                    </div>

                                    <i className="card-upgrade-icon fas fa-rocket"/>

                                </div>
                            )}
                            */}

                            {/*<div className="card-plan">
                                {myServiceInfoItem.planName}
                            </div>

                            <div className="card-details">
                                <div className="container">
                                    <div className="row">
                                        <div className="col">

                                            <ProgressBar
                                                icon={'fas fa-fw fa-cloud'}
                                                title={'Data'}
                                                value={'30 GB'}
                                                color={'red'}
                                                percentage={85}
                                                note={'25 GB Used'}
                                            />

                                        </div>
                                        <div className="col">

                                            <ProgressBar
                                                icon={'fas fa-fw fa-comment'}
                                                title={'Messages'}
                                                value={'100'}
                                                color={'green'}
                                                percentage={10}
                                                note={'10 Used'}
                                            />

                                        </div>
                                        <div className="col">

                                            <ProgressBar
                                                icon={'fas fa-fw fa-clock'}
                                                title={'Minutes'}
                                                value={'600'}
                                                color={'yellow'}
                                                percentage={66}
                                                note={'400 Used'}
                                            />

                                        </div>
                                    </div>
                                </div>
                            </div>*/}

                        </div>

                        <div className="card-footer">
                            <div className="card-footer-toolbar">

                                {/*<button className="btn btn-sm btn-fw-enable btn-light"
                                        data-target="default">
                                    View Usage
                                </button>*/}

                                {/*<button className="btn btn-sm btn-fw-enable btn-light"
                                        data-target="default">
                                    Change Plan
                                </button>*/}

                                {window.managePlanEnable &&
                                <button className="btn btn-sm btn-fw-enable btn-primary"
                                        onClick={this.showHideManagePlan}>
                                    Manage Plan
                                </button>
                                }

                            </div>
                        </div>

                    </div>
                </div>

                {/* FOR DEMO PURPOSES - SHOWN ONLY AFTER FIRST CARD
                {myServiceInfoItemIndex === 0 && (
                    <div className="cp-col col-12 d-flex">
                        <div className="card card-service card-service-promo">

                            <div className="card-caption">
                                <div className="card-left">

                                    <div className="card-icon">
                                        <i className="fas fa-ad"/>
                                    </div>

                                </div>
                                <div className="card-right">

                                    <div className="card-header">
                                        Special Offer: Get 20% off an iPad Pro!
                                    </div>

                                    <div className="card-description">
                                        Lorem ipsum dolor ist amet
                                    </div>

                                </div>
                            </div>

                            <div className="card-body">

                                <button className="btn btn-primary">View Details</button>

                            </div>

                        </div>
                    </div>
                )}
                */}

                {/* FOR DEMO PURPOSES - SHOWN ONLY AFTER FOURTH CARD
                {myServiceInfoItemIndex === 3 && (
                    <div className="cp-col col-12 col-lg-6 d-flex">
                        <div className="card card-service card-service-promo card-service-promo-small">

                            <div className="card-caption">

                                <div className="card-right">

                                    <div className="card-header">
                                        Special Offer: Get 20% off an iPad Pro!
                                    </div>

                                    <div className="card-description">
                                        Lorem ipsum dolor ist amet
                                    </div>

                                </div>

                            </div>

                            <div className="card-body">

                                <button className="btn btn-primary">Shop Now</button>

                            </div>

                        </div>
                    </div>
                )}
                */}

            </Fragment>
        )
    }
}

export default ServiceCard